import { render, staticRenderFns } from "./LightboxIframeCard.vue?vue&type=template&id=3cb39df0&scoped=true&"
import script from "./LightboxIframeCard.vue?vue&type=script&lang=js&"
export * from "./LightboxIframeCard.vue?vue&type=script&lang=js&"
import style0 from "./LightboxIframeCard.vue?vue&type=style&index=0&id=3cb39df0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb39df0",
  null
  
)

export default component.exports